var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualMessagingSystemDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 21.75V19.5H3V21.75H1.5C1.086 21.75 0.75 22.086 0.75 22.5C0.75 22.914 1.086 23.25 1.5 23.25H9C9.414 23.25 9.75 22.914 9.75 22.5C9.75 22.086 9.414 21.75 9 21.75H7.5ZM21 21.75V19.5H16.5V21.75H15C14.586 21.75 14.25 22.086 14.25 22.5C14.25 22.914 14.586 23.25 15 23.25H22.5C22.914 23.25 23.25 22.914 23.25 22.5C23.25 22.086 22.914 21.75 22.5 21.75H21ZM23.25 6.75C23.25 5.508 22.242 4.5 21 4.5H3C1.758 4.5 0.75 5.508 0.75 6.75V15.75C0.75 16.992 1.758 18 3 18H21C22.242 18 23.25 16.992 23.25 15.75V6.75ZM3 3H7.5C7.5 1.758 6.492 0.75 5.25 0.75C4.008 0.75 3 1.758 3 3ZM16.5 3H21C21 1.758 19.992 0.75 18.75 0.75C17.508 0.75 16.5 1.758 16.5 3Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualMessagingSystemDark);
export default __webpack_public_path__ + "static/media/Virtual_messaging_system_dark.3dbdda76.svg";
export { ForwardRef as ReactComponent };